import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from '@web/atoms';
import { BaseHeader, DiscountBanner } from '@web/molecules';
import { HeaderLogo } from '@web/molecules/Header/HeaderLogo';
import {
  BreadcrumbContainer,
  CurrentProgress,
  QuizHeaderWrapper,
} from './styles';

export const QuizHeader = ({
  currentStep,
  totalSteps,
  showPromoBar,
  discountBannerCopy,
  discountBannerBGColor,
  discountBannerFontColor,
  centerLogo = false,
  progress = true,
  overrideText = '',
  logoImage = null,
  logoUrl = '/',
}) => {
  const topHeaderSegment = showPromoBar && (
    <DiscountBanner
      promoMessage={discountBannerCopy}
      bgColor={discountBannerBGColor}
      fontColor={discountBannerFontColor}
      showLink={false}
    />
  );

  const centerHeaderSegment = centerLogo ? (
    <HeaderLogo
      logoImg={logoImage}
      logoSrText={'Ollie Home'}
      logoUrl={logoUrl}
    />
  ) : undefined;

  const rightHeaderSegment =
    progress || overrideText ? (
      <BreadcrumbContainer $progress={progress}>
        <CurrentProgress>
          {overrideText ? (
            <span>{overrideText}</span>
          ) : (
            <span>
              Step {currentStep} of {totalSteps}
            </span>
          )}
        </CurrentProgress>
        {progress && (
          <ProgressBar
            color="secondary.lilac"
            currentStep={currentStep}
            totalSteps={totalSteps}
            labelText={`Signup step ${currentStep} of ${totalSteps}`}
          />
        )}
      </BreadcrumbContainer>
    ) : undefined;

  return (
    <QuizHeaderWrapper
      $centerLogo={centerLogo}
      $withBreadcrumb={rightHeaderSegment}
    >
      <BaseHeader
        sticky={true}
        stickyBanner={false}
        hasBanner={false}
        data-testid="onboarding-quiz-header"
        topSegment={centerLogo ? null : topHeaderSegment}
        centerSegment={centerHeaderSegment}
        rightSegment={rightHeaderSegment}
        showLogo={!centerLogo}
        logoUrl={logoUrl}
        headerVerticalPadding={5}
      />
    </QuizHeaderWrapper>
  );
};

QuizHeader.displayName = 'QuizHeader';

QuizHeader.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  showPromoBar: PropTypes.bool,
  discountBannerCopy: PropTypes.string,
  discountBannerBGColor: PropTypes.string,
  discountBannerFontColor: PropTypes.string,
  centerLogo: PropTypes.bool,
  progress: PropTypes.bool,
  overrideText: PropTypes.string,
  logoUrl: PropTypes.string,
};
